export default __webpack_public_path__ + "assets/images/spinner.02e8b04eee98d841a4e2122ebc4a57a1.png";